import { Text, ScrollView, View, Image } from "react-native";
import { Pressable } from "react-native";
import { useDispatch, useSelector } from 'react-redux';
import styles from "@stylesheet";
import Modal from 'react-native-modal';
import { Title } from "@constants/Themed";
import { HIDE_LOCK_MODAL } from '@reduxLocal/actions/types';
import { DefaultRootState } from '@reduxLocal/persistState';
import React, { useState } from "react";
import { FontAwesome } from "@expo/vector-icons";
import loginUser from "@api/login";
import Form from "../../Global/Form";
import useForm from '@hooks/useForm';
import InputField from "../../Global/InputField";
import { useLottieAnim } from '@hooks/lottieHook';
import LottieView from '@utils/lottieAnimation';
import apis, { unlockUser } from "@api/api";

const LockModal = () => {
  const isVisible = useSelector((state: DefaultRootState) => state.modals.lockModal.modalDisplayed);
  const user = useSelector((state: DefaultRootState) => state.promiseData.data.userData.email)
  const [loginHovered, setLoginHovered] = useState(false);
  const [logoutHovered, setLogoutHovered] = useState(false);
  const animation = useLottieAnim();
  const dispatch = useDispatch();

  const formLoginContext = useForm({
    initialValues: {
      email: user,
      password: null,
    },
    onSubmit: async (formValues) => {
      await unlockUser(formValues)
    },
  })

  const handleLoginKeyDown = async (e: { nativeEvent: { key: string; }; }, formValues: any, data) => {
    if (e.nativeEvent.key == "Enter") {
      dispatch(loginUser(formValues, data));
    }
  }

  return (
    <Modal
      isVisible={isVisible}
      animationIn={'bounceInUp'}
      animationInTiming={500}
      animationOut={'slideOutUp'}
      hasBackdrop={true}
      backdropOpacity={.8}
      coverScreen={true}
    >
      <View style={{backgroundColor:'white', borderRadius: 20}}>
        <Text>Hi</Text>
      </View>
    </Modal>
  )
}
export default LockModal;